import React, { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';

const AppLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    // Only set valid languages. Any invalid route will hit the Fallback Route mapping in App.js
    if (lang === 'en' || lang === 'es') {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  }, [lang, i18n]);

  // If the parameter is not a supported language, redirect to the language redirector
  if (lang !== 'en' && lang !== 'es') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="app-container">
      <Navbar />
      <main style={{ minHeight: 'calc(100vh - var(--header-height))' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
